// Single source of truth for the brand palette.
// Imported by both tailwind.config.js (build-time) and WaveDivider.js
// (runtime SVG fills, where Tailwind classes can't apply).
//
// CommonJS so tailwind.config.js (also CJS) can `require()` this. ES-module
// consumers using `import x from './brandColors'` work via interop.

const brandColors = {
  background: "#FFF8F0",   // Warm white
  surfaceTint: "#F2E9D5",  // Warm oat — emphasis sections
  primary: "#C9876B",      // Terracotta clay
  primaryDark: "#B5704F",  // Terracotta darker — primary CTA hover
  accent: "#F67E7D",       // Warm rose
  accentDark: "#D86866",   // Rose darker — accent CTA hover
  secondary: "#843B62",    // Deep mauve
  text: "#333333",         // Body text
  textSecondary: "#555555",// Muted body text
  statusError: "#B5605C",  // Desaturated clay-red
  statusOk: "#7A8B6F",     // Desaturated sage
};

module.exports = brandColors;
